@if (textToBeCopied()) {
  <a aria-hidden="true" class="pi pi-copy" (click)="copyToClipboard($event)">
  </a>
}
